import { downgradeInjectable } from '@angular/upgrade/static';
import { NotebookFacade } from '@mode/notebooks/contract';
import {
  DataViewFacade,
  FlamingoFacade,
  ImportedDatasetFacade,
  PlanMetadataFacade,
  SwitchAttrsFacade,
  SwitchViewFacade,
  SwitchViewReorderingFacade,
} from '@mode/switch-views/contract';
import * as angular from 'angular';

export const DowngradedSwitchViewsDomainModule = angular
  .module('downgraded-switch-views-domain', [])
  .service('SwitchAttrsFacade', downgradeInjectable(SwitchAttrsFacade))
  .service('SwitchViewFacade', downgradeInjectable(SwitchViewFacade))
  .service('DataViewFacade', downgradeInjectable(DataViewFacade))
  .service('NotebookFacade', downgradeInjectable(NotebookFacade))
  .service('SwitchViewReorderingFacade', downgradeInjectable(SwitchViewReorderingFacade))
  .service('ImportedDatasetFacade', downgradeInjectable(ImportedDatasetFacade))
  .service('FlamingoFacade', downgradeInjectable(FlamingoFacade))
  .service('PlanMetadataFacade', downgradeInjectable(PlanMetadataFacade)).name;
